import React from "react";
import styled from "styled-components";
import { FlexContainer, FlexDiv, FlexSection } from "@/components/Atoms/Box";
import Image from "@/components/Atoms/Image";
import theme from "@/foundation/Theme";
import { Typography } from "@/foundation/Typography/V2";

const OurTeam = React.forwardRef((props, ref) => {
  const { data = {} } = props || {};
  return (
    <SectionWrap ref={ref}>
      <Container flexDirection={"column"}>
        <HeadWrap>
          <Typography
            variant={"label1"}
            color={theme.colorsV2.shyft.purple_text}
            textAlign="center"
          >
            {data?.testimonials?.title}
          </Typography>
        </HeadWrap>
        <CardWrap>
          {data?.testimonials?.components?.map((item, index) => {
            return (
              <Card key={index}>
                <TitleWrap justifyContent={"center"}>
                  <Typography
                    color={theme.colorsV2.gray.shade_700}
                    variant="heading6"
                    textAlign={"center"}
                  >
                    {item.sub_title}
                  </Typography>
                </TitleWrap>
                <ImageDiv justifyContent={"center"}>
                  <ImageWrap>
                    {item.image && <Image src={item.image} />}
                  </ImageWrap>
                </ImageDiv>
                <FlexDiv flexDirection={"column"}>
                  <Typography
                    variant={"label1"}
                    color={theme.colorsV2.gray.shade_800}
                    textAlign={"center"}
                  >
                    {item.title}
                  </Typography>
                  <Typography
                    variant={"paragraph4"}
                    color={theme.colorsV2.gray.shade_800}
                    textAlign={"center"}
                  >
                    {item.component_identifier}
                  </Typography>
                </FlexDiv>
              </Card>
            );
          })}
        </CardWrap>
      </Container>
    </SectionWrap>
  );
});

export default OurTeam;
const SectionWrap = styled(FlexSection)`
  background-color: ${theme.colorsV2.blueGray.shade_50};
  padding: 40px 0 32px;
`;
const Container = styled(FlexContainer)`
  @media only screen and (max-width: 1279px) {
    flex-direction: column;
  }
`;
const HeadWrap = styled(FlexDiv)`
  padding: 8px 16px;
  margin-bottom: 24px;
  justify-content: center;
`;
const CardWrap = styled(FlexDiv)`
  flex-wrap: wrap;
  margin: 0 -8px;
  @media only screen and (max-width: 1023px) {
    flex-direction: column;
  }
`;
const Card = styled(FlexDiv)`
  margin: 8px;
  background-color: ${theme.colors.white};
  padding: 40px;
  width: 100%;
  max-width: calc(50% - 16px);
  border-radius: 32px;
  flex-direction: column;
  @media only screen and (max-width: 1023px) {
    max-width: calc(100% - 16px);
  }
`;
const TitleWrap = styled(FlexDiv)`
  padding: 16px;
  margin-bottom: 16px;
  @media only screen and (max-width: 1023px) {
    padding: 8px;
    margin-bottom: 8px;
  }
`;
const ImageDiv = styled(FlexDiv)`
  margin-bottom: 16px;
  @media only screen and (max-width: 1023px) {
    margin-bottom: 8px;
  }
`;
const ImageWrap = styled(FlexDiv)`
  height: 64px;
  width: 64px;
  border-radius: 50%;
  overflow: hidden;
  img {
    height: 100%;
    width: 100%;
    max-height: 100%;
    object-fit: cover;
  }
`;
